module.exports = __webpack_public_path__ + "static/fatimah-e33ac36cb0171e12a16ee633d94540bb.png";